import { render, staticRenderFns } from "./report-click-adjustment-dialog-app.vue?vue&type=template&id=5c3d8876"
import script from "./report-click-adjustment-dialog-app.vue?vue&type=script&lang=js"
export * from "./report-click-adjustment-dialog-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports